import { render, staticRenderFns } from "./EventChart.vue?vue&type=template&id=276f4c06&"
import script from "./EventChart.vue?vue&type=script&lang=js&"
export * from "./EventChart.vue?vue&type=script&lang=js&"
import style0 from "./EventChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports